/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateEscalationTicket} from '../api'

export const useMutationUpdateEscalationTicket = createReactQueryMutationHook('updateEscalationTicket', updateEscalationTicket)
